// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"ef18fde2","611":"c209cc4c"}[chunkId] + ".chunk.css";
};